// 服务端已确认签名密钥为字符串 123，保留按环境调整的配置入口。
// 前端硬编码值可被提取，不能作为可靠的身份认证凭证。
export const PORTAL_SIGNATURE_SECRET_KEYS = {
  test: 'd3c27c5741cf3bbffa38389d21e5c3fc69a25cc74a8c307802edf14e07a44da7',
  preview: '839ea07e14fac3bd578c14db9e7c8693bbf32c38f31af54487d509c3f9ce2445',
  production: '839ea07e14fac3bd578c14db9e7c8693bbf32c38f31af54487d509c3f9ce2445',
};

// 预留统一配置入口，不从 URL、Cookie 或调用方参数读取签名密钥。
export const getPortalSignatureSecretKey = () => {
  const env = process.env.REACT_APP_ENV || 'test';
  const secretKey = Object.prototype.hasOwnProperty.call(PORTAL_SIGNATURE_SECRET_KEYS, env) ?
    PORTAL_SIGNATURE_SECRET_KEYS[env] : '';
  if (typeof secretKey !== 'string' || !secretKey.trim()) {
    throw new Error('门户安全签名密钥未配置');
  }
  return secretKey;
};
